var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "btn-group mb-1" },
        [
          _vm.canSeeSurveys
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "survey" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("surveySurveys")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canSeeGroups
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "groups" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("surveyGroups")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canSeeAdvanceRegistration
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "advanceRegistration" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("survey.tabs.advanceRegistration")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canSeeGroups
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "pinned" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("survey.tabs.pinnedResults")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canSeeAdvanceRegistrationApprovalGroups
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "advanceRegistrationConfig" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("survey.tabs.advanceRegistrationApprovalGroups")
                      ) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canSeeCockpit
            ? _c(
                "TabButton",
                {
                  attrs: { tab: "cockpit" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("visitorManagement.tabs.cockpit")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.canSeeSurveys
        ? _c("TabSurveys", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "survey",
                expression: "tab === 'survey'"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canSeeGroups
        ? _c("GroupsForSurvey", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "groups",
                expression: "tab === 'groups'"
              }
            ],
            attrs: { showPinnedGroupsOnly: false, remote: true }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canSeeAdvanceRegistration
        ? _c("AdvanceRegistration", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "advanceRegistration",
                expression: "tab === 'advanceRegistration'"
              }
            ],
            attrs: { remote: true }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canSeeGroups
        ? _c("GroupsForSurvey", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "pinned",
                expression: "tab === 'pinned'"
              }
            ],
            attrs: {
              canDeleteGroups: false,
              showPinnedGroupsOnly: true,
              remote: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canSeeAdvanceRegistrationApprovalGroups
        ? _c("AdvanceRegistrationConfig", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "advanceRegistrationConfig",
                expression: "tab === 'advanceRegistrationConfig'"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canSeeCockpit && _vm.tab === "cockpit" ? _c("TabCockpit") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }